import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import { IsDate, IsNumber, IsOptional } from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

@Index(['userIdLow', 'userIdHigh'], { unique: true })
export class UserPairLink extends BasicEntity {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Index()
  @Column({ type: 'int', nullable: false })
  userIdLow: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Index()
  @Column({ type: 'int', nullable: false })
  userIdHigh: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  sharedIpCount: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  sharedUaOnIpCount: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  concurrentWindowsCount: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Index()
  @Column({ type: 'int', nullable: false, default: 0 })
  linkStrengthMilli: number;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  @Index()
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  lastMatchedAt?: Date | null;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  collusionSignalCount: number;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  @Index()
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  lastCollusionSignalAt?: Date | null;
}
